// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCalendarPlus = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M7 2h2v2h6V2h2v2h3v7h-2v-1H6v8h5v2H4V4h3zM6 6h12v2H6z" />,
    <path d="M13 18h3v3h2v-3h3v-2h-3v-3h-2v3h-3z" />
  );
export default SvgIconCalendarPlus;
